













import { Component, Prop, Vue } from 'vue-property-decorator';
import palette from 'google-material-color';

function hash(data: string) {
  // eslint-disable-next-line no-bitwise
  return data.split('').map(a => a.charCodeAt(0)).reduce((a, b) => (b * 7) ^ a);
}

function selectColorName(n: number) {
  const colorNames = Object.keys(palette.palette).filter(name => name !== 'White' && name !== 'Black');
  return colorNames[n % colorNames.length];
}

@Component
export default class DiceAnimator extends Vue {
  @Prop({ required: true }) dice!: {
    key: string;
    faces: number;
    result: number;
  };

  shown: boolean = true;

  private get colorName(): string {
    const {
      key,
    } = this.dice;

    const colorKey = hash(`${key}-color`);
    return selectColorName(colorKey);
  }

  get backgroundColor(): string {
    return palette.get(this.colorName);
  }

  get color(): string {
    return palette.get('White', 'Secondary');
  }

  get firstColor(): string {
    return palette.get(['Red', 'Pink', 'Deep Orange'].indexOf(this.colorName) >= 0 ? 'White' : 'Red');
  }

  get outerStyle(): object {
    return {
      animationDelay: `${Math.random() / 2}s`,
    };
  }

  get innerStyle(): object {
    const noise = Math.random() * 0.3;
    return {
      animationDelay: `${3.5 + noise}s`,
      animationDuration: `${0.4 - noise}s`,
    };
  }

  onAnimationEnd(): void {
    this.shown = false;
  }
}
